import { format } from 'date-fns'
import { ru } from 'date-fns/locale'

/** «12 июня 2001» — значение карточки даты рождения (спека 02 §A2). */
export function formatBirthDate(date: Date): string {
  return format(date, 'd MMMM yyyy', { locale: ru })
}
